<template>
  <div />
</template>

<script>
import { getEventScope } from 'chimera/all/plugins/eventbus/scope'
import validatesWithApi from 'chimera/all/mixins/validatesWithApi'
import Cookies from 'js-cookie'

export default {
  name: 'AbstractContactForm',

  mixins: [validatesWithApi],

  props: {
    hubspotFormId: {
      type: String,
      required: true,
    },

    confirmationPath: {
      type: String,
      required: true,
    },

    errorPath: {
      type: String,
      default: '/error',
    },

    conversionName: {
      type: String,
      required: true,
    },
  },

  /**
   * @returns {{hubspotErrors: *[]}}
   */
  data() {
    return {
      hubspotErrors: [],
      submitBtnIsDisabled: false,
    }
  },

  watch: {
    /**
     * Perform form validation when we receive Hubspot form errors
     *
     * @param {Array} errors
     */
    hubspotErrors(errors) {
      this.validateForm()
    },
  },

  methods: {
    /**
     * @returns {Array}
     */
    getFormFields() {
      return []
    },

    /**
     * On form submit
     */
    onSubmit() {
      this.hubspotErrors = []

      const formIsValid = this.validateForm()
      if (formIsValid) {
        this.submitBtnIsDisabled = true
        this.postForm(this.getFormFields(), this.hubspotFormId)
          .then(() => {
            // Emit conversion with current scope before navigation starts.
            this.$eventBus.emitConversionEventInScope(getEventScope(), {
              type: this.conversionName,
            })
            this.$router.push({ path: this.confirmationPath })
          })
          .catch((error) => {
            // Non-400 errors are non-recoverable.
            const responseStatus = error.response && error.response.status
            if (responseStatus !== 400) {
              this.$eventBus.emitErrorAppErrorEvent(error)
              this.$router.push({ path: this.errorPath })
              return
            }

            // Parse the 400 content and extract fields with errors.
            const formErrors = error.response.data.errors || []
            this.hubspotErrors = this.parseHubspotFormErrors(formErrors)
            const context = {}
            this.hubspotErrors.forEach(({ field, type }) => {
              context['hubspot_' + field] = type
            })
            this.$eventBus.emitErrorAppErrorEvent(error, context)
          })
          .finally(() => {
            this.submitBtnIsDisabled = false
          })
      }
    },

    /**
     * @param {Array} formErrors
     * @returns {Array}
     */
    parseHubspotFormErrors(formErrors) {
      if (formErrors.length === 0) {
        return []
      }

      const extractFieldName = (message) =>
        /fields\.([a-zA-Z0-9-/]+)'/g.exec(message)[1]
      return formErrors.map(({ message, errorType }) => {
        return {
          field: extractFieldName(message),
          type: errorType,
        }
      })
    },

    /**
     * Validate form
     *
     * @returns {boolean}
     */
    validateForm() {
      return true
    },

    /**
     * Post form
     *
     * @param {Array} fields
     * @param {string} formId
     * @param {string} portalId
     * @returns {Promise<Response>}
     */
    postForm(fields, formId, portalId = '8674700') {
      // Current label (hidden field)
      fields.push({ name: 'label', value: process.env.concept })

      // User preferred language (hidden field)
      fields.push({
        name: 'hs_language',
        value: this.$i18n.locale.toLowerCase(),
      })

      const body = {
        submittedAt: new Date().getTime(),
        fields,
        context: {
          pageUri: document.URL,
          pageName: document.title,
        },
      }

      const hubspotUserToken = this.getHubspotUserToken()
      if (hubspotUserToken) {
        body.context.hutk = hubspotUserToken
      }

      let url = process.env.hubspotFormApi
      url = url.replace(':portalId', portalId)
      url = url.replace(':formId', formId)
      return this.apiPost(url, body)
    },

    /**
     * User token from hubspot cookie with id `hubspotutk`
     *
     * @returns {string|undefined}
     */
    getHubspotUserToken() {
      return Cookies.get('hubspotutk')
    },
  },
}
</script>
